export default "__VITE_ASSET__BBi4zffI__"